import React from 'react'
import type { ClinicProgram } from '@/services/clinicProgramService'
import GuidedProgramCard from './GuidedProgramCard'
import ClinicProgramCard from './ClinicProgramCard'

export interface ProgramCardProps {
  program: ClinicProgram
  index: number
  clinicId: string
  onSuccess: () => void
  clinicArchetype?: 'guided' | 'direct' | 'hybrid' | null
}

const ProgramCardByMode: React.FC<ProgramCardProps> = ({
  program,
  index,
  clinicId,
  onSuccess,
  clinicArchetype,
}) => {
  if (program.display_mode === 'protocol_showcase') {
    return (
      <GuidedProgramCard
        program={program}
        index={index}
        clinicId={clinicId}
        onSuccess={onSuccess}
        clinicArchetype={clinicArchetype}
      />
    )
  }

  return (
    <ClinicProgramCard
      program={program}
      index={index}
      clinicId={clinicId}
      onSuccess={onSuccess}
      clinicArchetype={clinicArchetype}
    />
  )
}

export default ProgramCardByMode
